import * as fetch from './fetch';

export { fetch };
